// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useGetAllocationRequestRows } from '../../pages/registry/allocationRequest/useGetAllocationRequestRows';

export const useInboundAllocationRequestCount = () => {
  const { rows, isError } = useGetAllocationRequestRows();
  if (isError) return 0;
  return rows.length;
};
